/** The one place a KPI total is divided by a span of days. */
import moment from 'moment';

const DATE_FORMAT = 'YYYY-MM-DD';

export const WEEKLY_THRESHOLD_DAYS = 7;

export const AVERAGE_UNAVAILABLE = 'N/A' as const;

export interface KpiAverages {
    weekly: number | typeof AVERAGE_UNAVAILABLE;
    daily: number | typeof AVERAGE_UNAVAILABLE;
}

/** Proportional: every day of the window counts exactly once. */
export const average = (total: number, days: number): KpiAverages => {
    // Both rates, not just the weekly one: a `0` here is indistinguishable
    // from a measured zero per day on the tile beside it.
    if (days <= 0) {
        return { weekly: AVERAGE_UNAVAILABLE, daily: AVERAGE_UNAVAILABLE };
    }
    return {
        weekly:
            days >= WEEKLY_THRESHOLD_DAYS
                ? total / (days / WEEKLY_THRESHOLD_DAYS)
                : AVERAGE_UNAVAILABLE,
        daily: total / days,
    };
};

/** Days an inclusive window covers. */
export const daysInPeriod = (period: {
    start: string;
    end: string;
}): number => {
    const days =
        moment(period.end, DATE_FORMAT).diff(
            moment(period.start, DATE_FORMAT),
            'days'
        ) + 1;
    return Number.isFinite(days) && days > 0 ? days : 0;
};
